<template>
    <ModalBase show-modal @close-modal="close" unpadded narrow class="logo-modal">
        <template v-slot:titlebar>
            <TitleBar variant-class="title-modal title-modal--simple">
                <template v-slot:pretitle>
                {{ $gettext('AI powered') }}
                </template>
                <template v-slot:title>
                    <div>{{ $gettext('Design your logo') }}</div>
                    <GekkoButton 
                        v-if="state !== 'init'" 
                        @click="state = 'init'" 
                        :text="$gettext('Back')"
                        icon="fa-solid fa-circle-arrow-left"
                        class="text-info px-0"
                        variant="link"/>
                </template>
            </TitleBar>
        </template>
        <template v-slot:maincontent>
            <div>
                <EmptyState v-if="state === 'init'">
                    <template v-slot:image>
                        <AnimationItem :animation="{ animationData: paintAnimation.default }"/>
                    </template>

                    <template v-slot:title>
                        {{ $gettext('Show us your style') }}
                    </template>

                    <template v-slot:content>
                        {{ $gettext('Start by uploading your own logo or generate a new one with AI.') }}
                    </template>

                    <template v-slot:cta>
                        <GekkoButton 
                            @click="state = 'edit'"
                            :text="$gettext('Upload')"
                            icon="fa-solid fa-upload"/>
                        <GekkoButton 
                            @click="state = 'generate'"
                            :text="$gettext('Generate')"
                            icon="fa-solid fa-paint-brush"/>
                    </template>
                </EmptyState>

                <EditLogo v-if="state === 'edit'" @logoSetToCompany="onLogoSetToCompany"/>

                <GenerateLogo v-if="state === 'generate'" @openEdit="onOpenEdit"/>
            </div>
        </template>
    </ModalBase>
</template>

<script>
import ModalBase from '@/components/base_components/ModalBase'
import TitleBar from '@/components/TitleBar'
import * as paintAnimation from '@/css/animations/paint.json'
import AnimationItem from '@/components/dashboard/ui/AnimationItem.vue'
import EditLogo from '@/components/logo_generator/EditLogo.vue'
import GenerateLogo from '@/components/logo_generator/GenerateLogo.vue'
import EmptyState from '@/components/ui/EmptyState'
import GekkoButton from '@/components/GekkoButton'

export default {
    name: 'LogoModal',
    components: {
        ModalBase,
        TitleBar,
        EmptyState,
        GekkoButton,
        AnimationItem,
        EditLogo,
        GenerateLogo
    },
    data() {
        return {
            state: 'init', // { init, edit, generate }
            paintAnimation: paintAnimation
        }
    },
    methods: {
        close () {
            this.$emit('close', false)
            document.body.classList.remove('modal-on')
        },
        onOpenEdit() {
            this.state = 'edit'
        },
        onLogoSetToCompany(obj) {
            this.$emit('logoSetToCompany', obj)
        }
    }
}
</script>

<style lang="scss">
.logo-modal {
  .gk-modal {
    min-height: 1000px;
    max-height: 1000px;
  }
}
</style>